import axios from 'axios';
import {
  API_URL,
  toSlideshow,
  fromSlideshow,
  pollingSubscription
} from './adapters';

// Slideshows are stored in the carousels collection. Rows synced from Google
// Sheets are owned by the sheet and the API rejects edits to them with a 409;
// rows created here are marked 來源='api' and survive the sync.

export const getAllSlideshows = async () => {
  const { data } = await axios.get(`${API_URL}/carousels`);
  return data.map(toSlideshow);
};

export const getSlideshow = async (slideshowId) => {
  try {
    const { data } = await axios.get(`${API_URL}/carousels/${slideshowId}`);
    return toSlideshow(data);
  } catch (error) {
    if (error.response?.status === 404) return null;
    throw error;
  }
};

// A device inherits the carousel of the company it belongs to.
export const getSlideshowsForDevice = async (deviceOrCompanyId) => {
  let companyId = deviceOrCompanyId;

  // Accept a device id too, resolving the owning company first.
  try {
    const { data: display } = await axios.get(`${API_URL}/displays/${deviceOrCompanyId}`);
    if (display?.公司ID) companyId = display.公司ID;
  } catch (error) {
    if (error.response?.status !== 404) throw error;
  }

  const { data } = await axios.get(`${API_URL}/carousels/company/${companyId}`, {
    params: { activeOnly: 'true' }
  });
  return data.map(toSlideshow);
};

export const createSlideshow = async (slideshowData) => {
  const { data } = await axios.post(`${API_URL}/carousels`, fromSlideshow(slideshowData));
  return toSlideshow(data);
};

export const updateSlideshow = async (slideshowId, updates) => {
  const { data } = await axios.put(
    `${API_URL}/carousels/${slideshowId}`,
    fromSlideshow(updates)
  );
  return toSlideshow(data);
};

export const deleteSlideshow = async (slideshowId) => {
  await axios.delete(`${API_URL}/carousels/${slideshowId}`);
  return true;
};

export const subscribeToSlideshows = (deviceOrCompanyId, callback) =>
  pollingSubscription(() => getSlideshowsForDevice(deviceOrCompanyId), callback);

export const subscribeToAllSlideshows = (callback) =>
  pollingSubscription(getAllSlideshows, callback);
